var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAllasPlusLogoRounded = function SvgAllasPlusLogoRounded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#FF5265"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M29.533 28.061V12.238h-8.09v1.37s-1.813-1.488-5.7-1.605c-2.955-.09-7.332 1.972-9.4 6.815-1.101 2.583-2.029 6.438-.654 9.948 3.953 10.092 13.02 8.068 13.02 8.068l2.735-8.029v7.99h8.128l2.08-8.734zm-8.067-.055s-.369-.578-1.054-.467c-.769.124-1.482.447-2.567.958-.87.41-2.098.774-3.275.107-1.187-.672-1.455-2.094-1.385-2.822.06-.616.436-1.376 1.405-1.736.894-.333 1.477-.264 1.477-.264s-1.253-2.095.353-3.323 3.858-.109 4.542 1.74c.978 2.645.504 5.807.504 5.807",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36.165 25.75h-4.513v-2.328h4.513v-4.525h2.321v4.525H43v2.328h-4.514v4.526h-2.32z"
  })));
};
export default SvgAllasPlusLogoRounded;